import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaSearch, FaCheckCircle, FaFileAlt, FaClipboardCheck } from 'react-icons/fa';
import './ReconnaissanceDiplomes.css';

const STEP_ICONS = [<FaSearch />, <FaCheckCircle />, <FaFileAlt />, <FaClipboardCheck />];

const ReconnaissanceDiplomes = () => {
  const { t } = useTranslation();
  const etapes = t('reconnaissancePage.steps', { returnObjects: true });

  return (
    <div className="reconnaissance-page">
      <section className="page-hero">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 text-center">
              <img src="/images/logo.jpeg" alt={t('common.altLogo')} className="hero-logo" />
            </div>
            <div className="col-lg-9 text-center">
              <h1 className="page-title">{t('reconnaissancePage.hero.title')}</h1>
              <p className="page-subtitle">{t('reconnaissancePage.hero.subtitle')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="processus-section py-5">
        <div className="container">
          <div className="row g-4">
            {etapes.map((etape, index) => (
              <div key={index} className="col-lg-3 col-md-6">
                <div className="processus-card">
                  <div className="processus-step-number">{index + 1}</div>
                  <div className="processus-icon">{STEP_ICONS[index]}</div>
                  <h3 className="processus-title">{etape.title}</h3>
                  <p className="processus-description">{etape.description}</p>
                  {index < etapes.length - 1 && (
                    <div className="processus-arrow"><span>→</span></div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="resultat-section py-5 bg-light">
        <div className="container">
          <div className="resultat-card">
            <div className="resultat-content">
              <div className="resultat-icon"><FaCheckCircle /></div>
              <h2 className="resultat-title">{t('reconnaissancePage.result.title')}</h2>
              <p className="resultat-text">{t('reconnaissancePage.result.text')}</p>
            </div>
            <div className="resultat-image">
              <img src="/images/diplome.png" alt={t('reconnaissancePage.result.title')} />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReconnaissanceDiplomes;
